import { gql } from '@apollo/client';

import { assignmentFragment } from '../fragments';
import { AssignmentFormInput } from '../../types/form';
import { Assignment } from '../../types';

export interface CreateAssignmentMutationVariables {
  courseId: string;
  input: AssignmentFormInput;
}

export interface CreateAssignmentMutationResult {
  assignment: Assignment;
}

export const createAssignmentMutation = gql`
  mutation CreateAssignmentMutation($courseId: String!, $input: CreateAssignmentMutationInput!) {
    assignment(courseId: $courseId, input: $input) @rest(type: "Assignment", path: "courses/{args.courseId}/assignments", method: "POST") {
      ...Assignment
    }
  }
  ${assignmentFragment}
`;
